import { useSelector } from 'react-redux';
import managerRoutes from '../../managerRoutes';
import propertyRoutes, { homeRoutes } from '../../propertyRoutes';
import safetyRoutes from '../../safetyRoutes';
import rootRoutes from '../../rootRoutes';
import providerRoutes from '../../providerRoutes';

const communityRoutes = [
  { name: 'Muro', to: '/dashboard/feed' },
  { name: 'Comunicados', to: '/dashboard/release' }
];

// Las entradas de navegación del usuario actual. Las usan el menú lateral y
// la paleta de comandos (⌘K), así que las dos muestran siempre lo mismo.
const useNavRoutes = () => {
  const { role, hasMultipleProperties } = useSelector(store => store.auth.user) || {};
  const { selectedProperty } = useSelector(store => store.property);
  const { selectedCondominium } = useSelector(store => store.condominium);

  // HO-HU-37: mientras una cuenta con varias propiedades no eligio
  // ninguna, el menu lateral solo muestra "Inicio" (donde esta el
  // selector) -- si no, se podia navegar directo a Mis finanzas/Mis
  // parqueos/etc. antes de elegir, y esas paginas mostrarian datos de
  // "alguna" propiedad (la primera, por el fallback de activeProperty())
  // en vez de pedir explicitamente que se elija una.
  const mustSelectProperty = role === 'property' && hasMultipleProperties && !selectedProperty;

  // Muro y Comunicados estaban solo en la barra superior. Con el menú lateral
  // como única navegación (la barra superior ya no repite enlaces) van aquí,
  // justo debajo de Inicio.
  const withCommunity = baseRoutes => {
    const showCommunity = selectedCondominium && (role === 'manager' || role === 'property') && !mustSelectProperty;
    if (!showCommunity) return baseRoutes;
    const [home, ...rest] = baseRoutes;
    return [home, ...communityRoutes, ...rest];
  };

  const routes = {
    property: withCommunity(mustSelectProperty ? [homeRoutes] : propertyRoutes),
    manager: withCommunity(managerRoutes),
    safety: safetyRoutes,
    root: rootRoutes,
    provider: providerRoutes
  };

  return {
    routes: routes[role] || [],
    role,
    mustSelectProperty,
    selectedCondominium
  };
};

// Lista plana de páginas con enlace: { name, to, group, route }. Los grupos
// sin condominio elegido (Administración) se omiten, igual que en el menú.
export const flattenRoutes = (routes, selectedCondominium) =>
  routes.flatMap(route => {
    if (!route.children) return route.to ? [{ name: route.name, to: route.to, group: null, route }] : [];
    if (route.name === 'Administración' && !selectedCondominium) return [];
    return route.children
      .filter(child => child.to)
      .map(child => ({ name: child.name, to: child.to, group: route.name, route: child }));
  });

export default useNavRoutes;
